import React from 'react';
import { useCrossBorderData } from "../../Components/DataRetention/CrossBorderData";
import { getBrandName } from "../../Components/getBrandName";
const CrossBorderData = () => {
  const { sections, generateContent } = useCrossBorderData();
  const { brandName} = getBrandName();

  return (
    <div className="privacy-policy-page">
      <div className="privacy-policy-heading text-center">
        <h2>Cross-Border Data Transfer Transparency Policy</h2>
        <p className="text-muted" style={{fontSize:"0.8rem"}}>Effective Date: <strong>July 3, 2025</strong></p>
      </div>

      <div className="privacy-container">
        <div className="container py-5">
          <div className="row">
            <div className="col-12">
        <p>
          At {brandName}, we understand that the privacy and security of your data are critical, especially when your information is stored or processed outside India. This policy explains how, where, and why your data may be transferred across borders, and how we ensure full transparency and compliance with Indian and international data protection standards.
          </p>
              {sections.map((section) => (
                <div key={section.id} className="mb-5">
                  <h5 className="fw-bold">{section.title}</h5>
                  <div className="text-muted">
                    {generateContent(section.id)}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CrossBorderData;
